module.exports = __webpack_public_path__ + "assets/images/XCD10.png";


//////////////////
// WEBPACK FOOTER
// ./client/app/assets/images/XCD10.png
// module id = 1475
// module chunks = 1